var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossBrowserTestingAutomation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fe8839;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.72,147.88c0-17.84,0-35.4,0-52.95.01-18.82,8.99-27.85,27.71-27.85,99.09,0,198.17-.01,297.26,0,18.2,0,27.32,9.2,27.32,27.57.01,81.03.01,162.06,0,243.09,0,18.27-9.17,27.41-27.46,27.44-13.08.02-26.16,0-40.28,0,0,7.36,0,14.48,0,21.6,0,6.77.04,13.54,0,20.31-.12,16.05-9.71,25.78-25.68,25.81-36.34.07-72.68.02-109.02.02-63.2,0-126.4,0-189.6,0-19.13,0-27.99-8.95-27.99-28.26,0-76.06,0-152.13,0-228.19,0-19.22,8.89-28.08,28.15-28.1,12.41-.01,24.83-.03,37.24-.05.44,0,.87-.15,2.35-.42ZM378.68,203.1H53.57c0,2.74,0,4.98,0,7.21,0,64.57,0,129.14,0,193.71,0,12.7,2.65,15.3,15.58,15.3,97.99,0,195.97,0,293.96,0,12.9,0,15.57-2.62,15.57-15.31,0-62.54,0-125.08,0-187.62,0-4.27,0-8.54,0-13.3ZM121.78,121.44v26.92c3.15,0,5.83,0,8.52,0,77.88,0,155.76,0,233.64,0,19.61,0,28.33,8.8,28.33,28.6,0,55.53,0,111.07,0,166.6,0,2.59,0,5.18,0,8.02,13.92,0,26.78.01,39.64,0,11.49-.01,14.5-2.97,14.5-14.34.01-69.75,0-139.51,0-209.26v-6.54H121.78ZM121.33,107.22h325.09c0-3.63,0-6.77,0-9.92,0-14.52-2.16-16.64-16.94-16.64-97.08,0-194.16,0-291.24,0-2.03,0-4.07-.09-6.09.03-6.82.39-10.46,3.82-10.77,10.53-.24,5.16-.05,10.34-.05,16ZM53.64,188.62h325.05c0-3.71,0-7.05,0-10.38,0-13.88-2.36-16.29-15.94-16.29-97.76,0-195.51,0-293.27,0-2.03,0-4.08-.12-6.09.08-5.7.57-9.24,3.78-9.66,9.48-.4,5.56-.09,11.18-.09,17.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.76,311.09c.02,55.91-45.59,101.48-101.59,101.5-56.01.02-101.58-45.43-101.67-101.41-.09-56.06,45.32-101.74,101.23-101.84,56.33-.11,102.01,45.45,102.03,101.76ZM253.48,344.52c4.26-22.81,4.45-44.86-.07-66.9h-74.48c-4.71,23.19-4.48,51.01.53,66.9h74.01ZM163.26,344.79v-67.66c-7.93,0-16.91-.16-25.88.17-1.34.05-3.24,2.11-3.8,3.64-7.37,19.99-7.36,40.07,0,60.06.56,1.52,2.47,3.57,3.81,3.62,8.97.32,17.95.17,25.86.17ZM269,344.8c7.94,0,16.49.18,25.02-.16,1.61-.07,4-1.92,4.58-3.49,7.4-19.96,7.47-40.04.15-60.07-.54-1.48-1.96-3.71-3.03-3.75-9.31-.3-18.64-.17-26.72-.17v67.64ZM182.36,263.28h67c-2.09-11.45-10.12-26.25-18.09-33.47-10.19-9.23-20.51-9.26-30.54.29-9.38,8.94-14.42,20.38-18.36,33.18ZM182.36,358.69c4.36,13.63,9.69,26.12,20.81,35.17,6.92,5.64,14.64,7.23,22.48,2.27,13.71-8.67,19.45-22.52,24.15-37.44h-67.44ZM142,263.52c4.96,0,8.31,0,11.67,0,13.68,0,13.5-.07,18.52-12.58,2.75-6.85,6.22-13.41,9.82-21.06-16.94,7.4-29.46,18.11-40,33.64ZM251.1,230.38c4.26,10.45,8.29,20.56,12.55,30.58.47,1.12,2.16,2.39,3.32,2.43,7.31.22,14.63.11,23.33.11-10.71-15.45-23.09-26.42-39.2-33.12ZM143.1,358.43c6.3,13.56,27.97,31.36,37.68,32.04-3.79-9.15-7.65-18.69-11.75-28.12-.67-1.54-2.35-3.67-3.66-3.74-7.31-.36-14.65-.17-22.28-.17ZM250.93,391.77c16.14-7.15,28.82-17.76,39.27-33.34-8.64,0-15.98-.19-23.29.17-1.31.06-3.02,2.17-3.68,3.71-4.1,9.44-7.96,18.98-12.3,29.46Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.75,100.98c-4.08.24-8.84-.28-9.21-5.68-.17-2.42,2.67-6.83,4.78-7.28,4.9-1.03,11.04-2.79,14.32,3.47,2.77,5.26-1.57,9.5-9.89,9.49Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.66,168.75c6.06-.3,10.7.64,10.77,6.55.08,6.39-4.84,7.02-9.95,7.02-4.81,0-9.37-.45-9.99-6.35-.44-4.18,2.15-6.64,6.3-7.19,1.32-.18,2.68-.03,2.86-.03Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.96,182.27c-4.25.24-9.01-.51-9.08-5.91-.03-2.5,3.3-6.76,5.68-7.21,4.87-.92,11.21-2.5,13.77,4.47,1.9,5.15-2.37,8.69-10.37,8.65Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.64,182.2c-6.18.3-10.82-.62-10.92-6.54-.1-6.4,4.82-7.02,9.93-7.02,4.8,0,9.37.43,10.01,6.33.45,4.17-2.14,6.64-6.29,7.21-1.32.18-2.68.03-2.74.03Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.3,
    y: 86.99,
    width: 23.52,
    height: 13.89,
    rx: 6.94,
    ry: 6.94
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.06,
    y: 168.33,
    width: 23.52,
    height: 13.89,
    rx: 6.94,
    ry: 6.94
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.52,
    y: 168.33,
    width: 23.52,
    height: 13.89,
    rx: 6.94,
    ry: 6.94
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.99,
    y: 168.33,
    width: 23.52,
    height: 13.89,
    rx: 6.94,
    ry: 6.94
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 154.63,
    y: 86.99,
    width: 23.52,
    height: 13.89,
    rx: 6.94,
    ry: 6.94
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 181.44,
    y: 86.99,
    width: 23.52,
    height: 13.89,
    rx: 6.94,
    ry: 6.94
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBrowserTestingAutomation);
export default __webpack_public_path__ + "static/media/Cross-Browser Testing Automation.cd3d975f691ec07f2dfb7f08395b53dc.svg";
export { ForwardRef as ReactComponent };